export const PROGRAMS = {
  telemedicine: 'Telemedicine',
  wellness_differential: 'Wellness Differential',
  disease_management_program: 'Disease Management',
  specialty_pharmacy_program: 'Specialty Pharmacy',
  health_reimbursement_arrangement: 'Health Reimbursement Arrangement',
  health_savings_account: 'Health Savings Account',
  flexible_spending_account: 'Flexible Spending Account',
  custom: 'Custom',
};

export const PROGRAMS_LIST = Object.entries(PROGRAMS);

export const CUSTOM_DETAILS_ABOVE = ['hsa_buyup'];
